export default "__VITE_ASSET__CMsQ4Kic__"